
<ngx-spinner bdOpacity="1" bdColor="rgba(97,197,212,0.07)"
  size="medium" color="#dd4b39" type="ball-spin-clockwise" fullScreen="true">
  <p style="color: #61c5d4;">Loading..</p>
</ngx-spinner>

<div *ngIf="!CustLogintoggle" [hidden]="isVerifyOtp" class="demo mt-0">
  <form [formGroup]="clientForm">
    <div class="emailWidth flex-grow-1">

      <div class="form-group mt-3 custom-width">
        <label class="form-label mb-2" for="card-email" style="font-family: 'Poly';">
          Email Address <span class="error-asterisk">*</span>
        </label>
        <input class="form-control" id="card-email" type="email" placeholder="Email Address" required formControlName="username" (keydown.enter)="moveFocus($event, passwordInput)" />
        <div class="text-danger" *ngIf="(submitted || clientControls.username.touched) && clientControls.username.errors?.pattern">
          Enter a valid Username.
        </div>
        <div class="text-danger" *ngIf="(submitted || clientControls.username.touched) && clientControls.username.errors?.required">
          Enter a valid Username.
        </div>
      </div>
      <div class="mt-3">
        <div class="d-flex justify-content-between">
          <label class="form-label mb-2" for="card-password" style="font-family: 'Poly';">Password <span class="error-asterisk">*</span></label>
        </div>
        <input [type]="changeType ? 'password' : 'text'" class="form-control"
          placeholder="Password" required id="card-password"
          #passwordInput formControlName="password" (keyup.enter)="clientLogin()"/>
        <span class="form-control-feedback" (click)="toggleShow()">
          <i class=" p-1 " [ngClass]="visible ? 'fa fa-eye':'fa fa-eye-slash'"></i>
        </span>
        <!-- <div class="text-danger" *ngIf="(submitted || clientControls.password.touched) && clientControls.password.errors?.pattern">
          Enter a valid Username.
        </div> -->
        <div class="text-danger" *ngIf="(submitted || clientControls.password.touched) && clientControls.password.errors?.required">
          Enter a valid Password.
        </div>
      </div>
      <div class="row flex-between-center mt-3">
        <div class="col-auto">
          <div class="form-check mb-0">
            <input class="form-check-input" type="checkbox" formControlName="rememberme"
                id="card-checkbox" checked="checked" />
            <label class="form-check-label mb-0"
                for="card-checkbox" style="font-family: 'Poly';">Remember me</label>
          </div>
        </div>
        <div class="col-auto">
          <a class="fs--1" style="font-size: 10px!important;font-family: 'Poly';" routerLink="/auth/forget-password">
            Forgot Password?
          </a>
        </div>
      </div>
      <div class="mt-3">
        <button class="login-btn d-block w-100 mt-3" type="button"
          [disabled]="isLoginBtn" (click)="clientLogin()">
          <span class="spinner-border spinner-border-sm" *ngIf="isLoginBtn"
            role="status" aria-hidden="true"></span>
          <span style="font-family: 'Poly';">Log In</span>
        </button>
      </div>
    </div>
  </form>
</div>

<div *ngIf="CustLogintoggle" [hidden]="isVerifyOtp" class="demo mt-0">
  <form [formGroup]="custForm" style="height:265px;">
    <div class="custFormWidth flex-grow-1">
      <div class="PhoneWidth my-3">
        <label class="form-label" style="font-family: 'Poly';margin-left: 5px;">Phone #</label>
        <mat-form-field class="example-full-width" appearance="outline">
          <input type="text" matInput placeholder="Enter contact # here..." formControlName="username"
            minlength="9" maxLength="10" ngxOnlyNumbers autocomplete="off"
            (keyup.enter)="sendOtp()"/>

        </mat-form-field>

        <mat-error class="text-danger"
        *ngIf="(submitted || customControls.username.touched) && customControls.username.errors?.pattern">
        Enter a valid contact # .
    </mat-error>
    <mat-error class="text-danger"
        *ngIf="(submitted || customControls.username.touched) && customControls.username.errors?.required">
        Enter a valid contact #.
    </mat-error>
    <mat-error *ngIf="customControls.username.errors?.maxlength">
      Contact # should be maximum 10 digits.
    </mat-error>
    <mat-error *ngIf="customControls.username.errors?.minlength">
        Contact # should be minimum 9 digits.
    </mat-error>
      </div>
      <div class="mb-3 form-group" *ngIf="isOtpField">
        <div class="d-flex justify-content-between">
          <label class="form-label" for="card-otp" style="font-family: 'Poly';padding-bottom: 10px;">OTP</label>
        </div>
        <input type="password" (keypress)="numberOnly($event)" (keyup.enter)="verifyOtp()"
            class="form-control" id="card-otp" formControlName="mobileOtp">
        <div class="row flex-between-center">
          <div class="col-auto"></div>
          <div class="col-auto text-center">
            <button class="btn btn-link fs--2" [disabled]="isLoginBtn"
              (click)="customerLoginResendOtp()" type="button"
              [disabled]="messageSuccess" style="border: none;">
              <span class="spinner-border spinner-border-sm"
                *ngIf="isLoginBtn" role="status"
                aria-hidden="true"></span>
              <span style="font-family: 'Poly';">Resend OTP</span>
            </button>
          </div>
        </div>
        <div class="mb-3">
          <button class="login-btn d-block w-100 mt-3"
            [disabled]="isLoginBtn" (click)="verifyOtp()">
            <span class="spinner-border spinner-border-sm"
                *ngIf="isLoginBtn" role="status" aria-hidden="true"></span>
            <span style="font-family: 'Poly';">Login</span>
          </button>
        </div>
      </div>
      <div class="row flex-between-center">
        <div class="col-auto">
          <div class="form-check mb-0">
            <input class="form-check-input" type="checkbox"  formControlName="rememberme"
                id="card-checkbox" checked="checked" />
            <label class="form-check-label mb-0" for="card-checkbox" style="font-family: 'Poly';">
              Remember me
            </label>
          </div>
        </div>
        <div class="col-auto">
          <a class="fs--1" style="font-size: 10px!important;font-family: 'Poly';" routerLink="/auth/forget-password">
            Forgot Password?
          </a>
        </div>
      </div>
      <div class="mb-3">
        <button class="login-btn d-block w-100 mt-3" type="button"
          [disabled]="isLoginBtn" *ngIf="!isOtpField" (click)="sendOtp()">
          <span class="spinner-border spinner-border-sm" *ngIf="isLoginBtn"
            role="status" aria-hidden="true"></span>
          <span style="font-family: 'Poly';">Send OTP</span>
        </button>
      </div>
    </div>
  </form>
</div>

<div *ngIf="isVerifyOtp"  class="demoOTP">
  <div class="p-4 flex-grow-1">
    <div class="alert alert-success" *ngIf="successful" role="alert" style="font-family: 'Poly';">
      OTP has sent successfully to your Email-Id and Contact #
    </div>
    <h3 style="font-family: 'Poly';">Verify as {{ userName }}</h3>
    <form [formGroup]="otpClientData">
      <div class="row gx-2">
        <div class="mb-3 col-sm-12">
          <label class="form-label" for="card-email" style="font-family: 'Poly';">Enter Email OTP</label>
          <input class="form-control" (keypress)="numberOnly($event)"
            formControlName="emailotp" type="text" id="card-email" />
        </div>
      </div>
      <div class="mb-3">
        <button class="login-btn d-block w-100 mt-3" type="submit"
          [disabled]="isLoginBtn" (click)="verifyClientOtp()" name="submit">
          <span class="spinner-border spinner-border-sm" *ngIf="isLoginBtn"
              role="status" aria-hidden="true"></span>
          <span style="font-family: 'Poly';">Verify</span>
        </button>
        <a class="text-decoration-underline mt-3"
          (click)="hideshowVerifylogin()">
          <span style="font-family: 'Poly';">Back to Login</span>
        </a>
      </div>
    </form>
  </div>
</div>

<button class="btn mt-2" data-bs-toggle="modal" data-bs-target="#sessionExistsModal" hidden id="trigger-modal"></button>

<div class="modal fade" id="sessionExistsModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 350px">
        <div class="modal-content position-relative">
            <div class="position-absolute top-0 end-0 mt-2 me-2 z-index-1">
                <a class="btn-close btn btn-sm btn-circle d-flex flex-center transition-base" data-bs-dismiss="modal"
                    aria-label="Close"></a>
            </div>
            <div class="modal-body p-0">
                <div class="rounded-top-lg py-3 ps-4 pe-6 bg-light">
                    <h2 class="mb-1 text-center font-weight-bold" style="font-weight: 500;font-family: 'Poppins';"
                        id="sessionModalLabel">
                        Session Already Exists
                    </h2>
                </div>
                <h4 class="text-center" style="font-family: 'Poppins';">
                    A session is already active. Would you like to close the register?
                </h4>
            </div>
            <div class="modal-footer justify-content-center">
                <a class="btn btn-outline-success" data-bs-dismiss="modal">Cancel</a>
                <a class="btn btn-outline-danger" (click)="redirectToCloseRegister()" data-bs-dismiss="modal">Redirect to Close Register</a>
            </div>
        </div>
    </div>
</div>
